//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { article_list, article_top, article_delete, article_save, article_update } from "@/request/api.admin/article";
export default {
  data: function data() {
    return {
      loadingData: true,
      params: {
        title: '',
        page: 1,
        limit: 20,
        total: 0
      },
      list: []
    };
  },
  created: function created() {
    this.getArticle();
  },
  mounted: function mounted() {},
  methods: {
    onSearch: function onSearch() {
      // if(this.params['title']){
      this.getArticle(); // }
    },
    getArticle: function getArticle() {
      var _this = this;

      this.loadingData = true;
      article_list(this.params).then(function (res) {
        // console.log(res)
        if (res.code === 0) {
          _this.list = res['page']['list'];
          _this.params['page'] = res['page']['currPage'];
          _this.params['limit'] = res['page']['pageSize'];
          _this.params['total'] = res['page']['totalCount'];
        }
      }).then(function () {
        _this.loadingData = false;
      });
    },
    onIsTopChange: function onIsTopChange(index) {
      var _this2 = this;

      var scorce = !this.list[index]['isTop'];
      var id = this.list[index]['id'];
      article_top({
        id: id,
        isTop: this.list[index]['isTop']
      }).then(function (res) {
        // console.log(res)
        if (res.code !== 0) {
          _this2.list[index]['isTop'] = scorce;
        }
      });
    },
    onEdit: function onEdit(index) {
      this.$router.push({
        path: 'article_add',
        query: {
          id: this.list[index]['id']
        }
      });
    },
    onDel: function onDel(index) {
      var _this3 = this;

      console.log(index, this.list[index]['id']);
      var ids = [this.list[index]['id']];
      article_delete(ids).then(function (res) {
        if (res.code === 0) {
          _this3.getArticle();
        }
      });
    },
    handleSizeChange: function handleSizeChange(size) {
      this.params.limit = size;
      this.params.page = 1;
      this.getArticle();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.params.page = page;
      this.getArticle();
    }
  }
};